import useAuthStore from "stores/useAuthStore";

export default function useShowDisabledTags() {
  return useAuthStore(
    state => state.userAuth?.sidebar_settings?.show_disabled_tags === true
  );
}
